import { Box, Button, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import UnuHealthLogo from "./assets/unu-health-logo.svg";
import LibertyLogo from "./assets/liberty-logo.svg";
import DecorativePatternBottomLeft from "./assets/decorative-pattern-bottom-left.svg";
import DecorativePatternTopRight from "./assets/decorative-pattern-top-right.svg";

interface UserTypeSelectionScreenProps {
  onCustomerClick: () => void;
  onTestUserClick: () => void;
}

const UserTypeSelectionScreen = ({
  onCustomerClick,
  onTestUserClick,
}: UserTypeSelectionScreenProps) => {
  const { t } = useTranslation();
  return (
    <Stack
      height="100%"
      justifyContent="space-between"
      position="relative"
      overflow="hidden"
      p={2}
      sx={{ background: (theme) => theme.palette.primary.main }}
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        flex={1}
        textAlign="center"
        gap={5}
      >
        <Box
          component="img"
          src={UnuHealthLogo}
          alt="Unu Health logo"
          style={{ width: "100%", maxWidth: 214, height: "auto" }}
        />
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          gap={1}
        >
          <Typography
            color="white"
            textAlign="center"
            fontSize={14}
            fontWeight={500}
            lineHeight="130%"
          >
            {t("PublicBinahScanFlow.userTypeSelection.partnershipText")}
          </Typography>
          <Box
            component="img"
            src={LibertyLogo}
            alt="Partner logo"
            style={{ width: "100%", maxWidth: 214, height: "auto" }}
          />
        </Box>
      </Box>

      <Stack spacing={2}>
        <Button
          fullWidth
          variant="contained"
          sx={{
            backgroundColor: "white",
            color: (theme) => theme.palette.primary.main,
          }}
          onClick={onCustomerClick}
        >
          {t("PublicBinahScanFlow.userTypeSelection.buttonLabel.customer")}
        </Button>
        <Button
          fullWidth
          variant="outlined"
          sx={{ borderColor: "white", color: "white" }}
          onClick={onTestUserClick}
        >
          {t("PublicBinahScanFlow.userTypeSelection.buttonLabel.testUser")}
        </Button>
      </Stack>

      {/* Decorative background patterns */}
      <Box
        component="img"
        src={DecorativePatternBottomLeft}
        alt=""
        aria-hidden="true"
        position="absolute"
        width={112}
        height={263}
        sx={{ bottom: 80, left: 0, pointerEvents: "none" }}
      />
      <Box
        component="img"
        src={DecorativePatternTopRight}
        alt=""
        aria-hidden="true"
        position="absolute"
        width={202}
        height={131}
        sx={{ top: 0, right: 0, pointerEvents: "none" }}
      />
    </Stack>
  );
};

export default UserTypeSelectionScreen;
